export default {"src":"/_next/static/media/atalon-logo-simple.18318470.svg","height":16,"width":16};